<!--  添加、编辑协议运输单位信息 -->
<template>
  <div class="addCheck">
    <el-drawer :title="form.id ? '修改' : '添加'" :visible.sync="userOpenFlag" @close="handleClose" @open="openMap"
      direction="rtl" size="40%">
      <div class="demo-drawer__content">
        <div>
          <el-form :model="form" :rules="dwFormRules" ref="addDwForm" :label-position="'top'" size="small">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item class="width-max" label="企业名称" prop="companyName">
                  <el-input size="small" v-model="form.companyName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="width-max" label="道路运输经营许可证编号" prop="licenseNo">
                  <el-input size="small" v-model="form.licenseNo"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item class="width-max" label="经营范围" prop="businessScope">
                  <el-input size="small" v-model="form.businessScope"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item class="width-max" label="证件有效期" prop="licenseDateTime">
                  <el-date-picker style="width: 100%;" v-model="form.licenseDateTime" type="daterange"
                    value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item class="width-max" label="协议服务期限" prop="protocolDateTime">
                  <el-date-picker style="width: 100%;" v-model="form.protocolDateTime" type="daterange"
                    value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>

            </el-row>
          </el-form>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <el-button type="primary" @click="saveData">保存</el-button>
        <el-button @click="userOpenFlag = false">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "addTransportCompany",
  props: {
  },
  data() {
    return {
      dwFormRules: {
        companyName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        licenseNo: [
          { required: true, message: "请输入道路运输经营许可证编号", trigger: "blur" },
        ],
        businessScope: [
          { required: true, message: "请输入经营范围", trigger: "blur" },
        ],
        licenseDateTime: [
          { required: true, message: "请选择证件有效期", trigger: "change" },
        ],
        protocolDateTime: [
          { required: true, message: "请选择协议服务期限", trigger: "change" },
        ],
      },
      userOpenFlag: false,
      form: {
        "companyName": '',
        "licenseNo": "",
        "businessScope": '',
        "startLicense": '',
        "endLicense": '',
        "startProtocol": "",
        "endProtocol": "",
      },

    };
  },
  methods: {
    lookUserDrawerOpen(val) {
      //编辑
      if (val) {
        let { startLicense, endLicense, startProtocol, endProtocol } = val;
        if (startLicense || endLicense) {
          this.form.licenseDateTime = [startLicense, endLicense];
        } else {
          this.form.licenseDateTime = []
        }
        if (startProtocol || endProtocol) {
          this.form.protocolDateTime = [startProtocol, endProtocol];
        } else {
          this.form.protocolDateTime = []
        }
        this.form = this.$_.cloneDeep(val);
      } else {
        this.form = {
          "companyName": '',
          "licenseNo": "",
          "businessScope": '',
          "startLicense": '',
          "endLicense": '',
          "startProtocol": "",
          "endProtocol": "",

          licenseDateTime: [],
          protocolDateTime: []
        };

      }
      this.userOpenFlag = true;
    },
    // 弹窗打开时初始化事件
    openMap() {
      this.$nextTick(() => { });
    },
    handleClose() { },
    saveData() {
      this.$refs.addDwForm.validate((valid) => {
        if (valid) {

          let { licenseDateTime, protocolDateTime, ...formData } = this.form;

          if (licenseDateTime && licenseDateTime.length > 0) {
            formData.startLicense = licenseDateTime[0];
            formData.endLicense = licenseDateTime[1];
          }
          if (protocolDateTime && protocolDateTime.length > 0) {
            formData.startProtocol = protocolDateTime[0];
            formData.endProtocol = protocolDateTime[1];
          }


          let url = this.$api.transportCompanies.add;
          this.$axios.post(url, formData, false).then((res) => {
            if (res.data.code == 0) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.$parent.getOtherCompanies();
              this.userOpenFlag = false;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          });

        } else {
          console.log("error submit!!");
          return false;
        }
      });

      // let formData = this.form;
      // let url = this.$api.tzSolids.tzSolids;
      // this.$axios.post(url, formData, false).then((res) => {
      //   if (res.data.code == 0) {
      //     this.$message({
      //       type: "success",
      //       message: res.data.msg,
      //     });
      //     this.$parent.getList();
      //     this.userOpenFlag = false;
      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.data.msg,
      //     });
      //   }
      // });
    },
  },
  beforeCreate() { },
  created() { },
  mounted() {
    // this.list = this.states.map((item) => {
    //   return { value: `value:${item}`, label: `label:${item}` };
    // });
  },
};
</script>

<style lang="scss" scoped>
.addCheck {


  /deep/.el-drawer__body {
    position: relative;
  }

  .demo-drawer__footer {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>